module.exports = __webpack_public_path__ + "static/VWT20_Funktion04_Web_800x800-200x200-98f66a39a61d01a918783db68b8e9ba0.png";